<div class="terms-conditions-modal">
	<div class="dialog-content">
		<div class="t-c-icon w-full overflow-hidden">
			<img src="assets/images/svgs//business-tc-icon.svg" alt="">
		</div>
		<div class="flex flex-col pt-[24px] pl-[24px] md:pl-[50px] pr-[24px] md:pr-[50px] pb-[24px] md:pb-[50px] gap-[24px]">
			<div class="flex flex-col gap-[8px]">
				<div class="title text-center font-bold text-black text-[24px] md:text-[32px] leading-[110%]">
					Review & Accept Terms & Conditions for POS Terminal Assignment
				</div>
				<div class="flex flex-col description text-center text-[12px] md:text-[16px] text-black leading-[140%] pl-[24px] pr-[24px]">
					<span>
						To complete the POS terminal setup for <span class="font-semibold">{{businessName}}</span>, 
						please review and accept our Terms & Conditions.
					</span>
					<span>
						This step is required before we can assign terminals to your business
					</span>
				</div>
				<div *ngIf="errorMessage">
					<app-custom-error-display [errorMessage]="errorMessage"/>
				</div>
			</div>
			<div class="tc-actions flex flex-col gap-4">
				<div>
					<app-custom-button (submitForm)="navigateToTermsAndConditionsDetails()" text="Review Terms & Conditions" type="primary"/>
				</div>
				<div class="text-center" *ngIf="!isGracePeriodExpired">
					<app-custom-button text="I’ll do it later" type="link" (submitForm)="close()"/>
				</div>
				<div class="text-center" *ngIf="isGracePeriodExpired">
					<app-custom-button text="Back to Login" type="link" (submitForm)="backToLogin()"/>
				</div>
			</div>
		</div>
	</div>
</div>